<ng-container rutsBlock="cc-notification-banner">
    <p rutsElem="text" [innerHTML]="text()"></p>

    @switch (theme()) {
        @case (Theme.Alert) {
            <cc-icon-button
                rutsElem="close"
                icon="times"
                color="secondary"
                size="sm"
                ariaLabel="закрыть"
                (clickEvent)="onClose()" />
        }
        @case (Theme.Info) {
            <button rutsElem="close" type="button" (click)="onClose()">
                {{ closeLabel() }}
            </button>
        }
    }
</ng-container>
